import React, { FC } from 'react'
import { Grid, Typography, useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { Link } from '@src/components/Link'
import { useSavedCartsQuery } from '@src/queries/SavedCartsQuery.generated'
import { FormattedDate, FormattedMessage } from 'react-intl'
import messages from '@utils/messages'
import { orderCenterRoutes } from '@src/routes'
import ContentLoadingSkeleton from './ContentLoadingSkeleton'
import ContentRow from './ContentRow'
import ListError from '@src/components/ListError'
import { sendCommonDetailClickEvent } from '@src/utils/analytics'
import {
  DejaNewEventCategory as eventCategory,
  DejaNewEventAction as eventAction,
  DejaNewEventLabel as eventLabel,
} from '@utils/analytics/enums'

const SAVED_CARTS_DEFAULT = 5

const SavedCarts: FC<{
  handleSavedCartClick: (data: any) => void
}> = ({ handleSavedCartClick }) => {
  const theme = useTheme()
  const isLarge = useMediaQuery(theme.breakpoints.up('lg')) === true
  const { loading, error, data } = useSavedCartsQuery({
    ssr: false,
  })

  if (loading)
    return <ContentLoadingSkeleton numberOfRecentItems={SAVED_CARTS_DEFAULT} />

  const savedCarts = data?.getSavedCarts?.savedCartSearchModels

  if (error || !savedCarts) return <ListError />

  return (
    <>
      {!savedCarts.length ? (
        <FormattedMessage
          id="NO_RESULTS_FOUND"
          defaultMessage="No results found"
        />
      ) : (
        <>
          {savedCarts
            .sort((a, b) => b.savedDate - a.savedDate)
            .slice(0, SAVED_CARTS_DEFAULT)
            .map((savedCart, index) => (
              <ContentRow
                key={index}
                firstColumn={savedCart.cartName}
                firstColumnWidth={7}
                onClick={() => handleSavedCartClick(savedCart)}
                secondColumn={
                  <Typography
                    variant="body2"
                    align={!isLarge ? 'left' : 'right'}
                  >
                    <FormattedDate
                      value={new Date(savedCart.savedDate)}
                      year="numeric"
                      month="short"
                      day="numeric"
                    />
                  </Typography>
                }
              />
            ))}
          <Grid
            item
            xs={12}
            onClick={() => {
              sendCommonDetailClickEvent(
                {
                  event: 'quick_order_widget_interaction',
                  action: 'visit all saved carts',
                  section: 'add to quick order',
                  component: 'right rail',
                  elementType: 'link',
                  elementText: 'go to saved carts',
                  linkUrl: orderCenterRoutes.savedCarts(),
                  coreEvent: 'no',
                },
                {
                  eventCategory: eventCategory.QuickOrderPage,
                  eventAction: eventAction.SavedCarts,
                  eventLabel: eventLabel.GoToSavedCarts,
                  eventInteractionType: 0,
                }
              )
            }}
          >
            <Link href={orderCenterRoutes.savedCarts()}>
              <a>
                <FormattedMessage {...messages.GO_TO_SAVED_CARTS} />
                {' >'}
              </a>
            </Link>
          </Grid>
        </>
      )}
    </>
  )
}

export default SavedCarts
